<div class="reporting-container">
    <div class="description">
        <h2>Play Reports</h2>
    </div>
    <div class="inner-container">
        <div class="results-chart-container">
            <r1-compass-lib-report-chart [chartData]="chartData()" [chartView]="chartView" />
        </div>
        <r1-compass-lib-date-picker (dateChange)="onDateChange($event)" [preSelectedDate]="selectedDate" />
        <div class="results-table-container">
            <r1-compass-lib-report-table
                [reportData]="reportData()"
                [appSpecificColumns]="appSpecificColumns"
                [appSpecificDetails]="appSpecificDetails"
                [appSpecificErrorLinks]="[]"
                [errorTableData]="[]"
                [interactionErrorTableData]="interactionErrorTableData()"
                (expandRow)="getInteractionErrorTableData($event)"
                (downloadSupportDetails)="downloadSupportData($event)" />
        </div>
    </div>
</div>
